import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { ServicesSection } from '../components/ServicesSection';
import { ContactCTA } from '../components/ContactCTA';
export function ServicesPage() {
  return <main data-id="element-904">
      <PageBanner title="Our Services" subtitle="Comprehensive home healthcare solutions tailored to your unique needs." breadcrumbs={[{
      label: 'Services',
      path: '/services'
    }]} data-id="element-905" />
      <ServicesSection data-id="element-906" />
      <ContactCTA data-id="element-907" />
    </main>;
}